import moment from "moment";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import ReactPaginate from "react-paginate";

const RegisterUserListTable = (props) => {
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 5;
  const { data, tableHead, auditionName, eventEl } = props;


  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      <>
        <div className="py-3">
          <h3 className="text-light text-center bg-dark py-3">
            {auditionName}
          </h3>
          <div className="row">
            <Table
              className="tableBorder my-2"
              striped
              bordered
              hover
              variant="dark"
            >
              <thead>
                <tr>
                  {tableHead &&
                    tableHead.map((heading) => (
                      <th className="text-light tableHeader text-center">
                        {heading}
                      </th>
                    ))}
                </tr>
              </thead>

              <tbody>
                {currentItems ? (
                  currentItems.map((participant, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>
                        {participant.user?.first_name}{" "}
                        {participant.user?.last_name}
                      </td>
                      <td>{participant.user?.phone}</td>
                      <td>{participant.user?.email}</td>
                      <td> {auditionName}</td>
                      <td>
                        {moment(eventEl.start_date).format("LL")} -{" "}
                        {moment(eventEl.end_date).format("LL")}{" "}
                      </td>
                      <td>
                        <input type="file" />
                      </td>
                      <td>
                        <button className="btn btn-primary">Submit</button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <>
                    <h3 className="text-danger">No Data Found</h3>
                  </>
                )}
              </tbody>
            </Table>
          </div>
        </div>

        <div id="react-paginate">
          <ReactPaginate
            breakLabel="..."
            nextLabel="next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            pageCount={pageCount}
            previousLabel="< previous"
            renderOnZeroPageCount={null}
            breakLinkClassName={"page-link"}
            containerClassName={"pagination"}
            pageLinkClassName={"page-link"}
            previousLinkClassName={"page-link"}
            nextLinkClassName={"page-link"}
            activeClassName={"active"}
          />
        </div>
      </>
    </>
  );
};

export default RegisterUserListTable;
